import React from 'react';
import {Card,Button,Divider,TextField, FormLabel, Paper, IconButton} from '@mui/material';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InfoMessage2 from '../tools/InfoMessage2';
import * as ETVConstants from '../ETVConstants';
import { Delete, Save } from '@mui/icons-material';

const MAX_IO_BITS = 32;
const MAX_FLOOR_BITS = 32;
class EditIO extends React.Component {

    state = {
		ioMap: {
			bit_0:'bit_0_floor', bit_1:'bit_1_floor', bit_2:'bit_2_floor', bit_3:'bit_3_floor', bit_4:'bit_4_floor', bit_5:'bit_5_floor', bit_6:'bit_6_floor', bit_7:'bit_out_of_service', bit_8:'bit_arriving',bit_9:'bit_overload',bit_10:'bit_up',	bit_11:'bit_down',bit_12:'bit_fire_alarm',bit_13:'bit_door_state_1',bit_14:'bit_door_state_2',bit_15:'bit_intercom',
			bit_16:'-1', bit_17:'-1', bit_18:'-1', bit_19:'-1', bit_20:'-1', bit_21:'-1', bit_22:'-1', bit_23:'-1', bit_24:'-1',bit_25:'-1',bit_26:'-1',bit_27:'-1',bit_28:'-1',bit_29:'-1',bit_30:'-1',bit_31:'-1'
		},
		door_map: {closed:'10',opening:'11',open:'01',closing:'11'},
		xor_mask: '0'.repeat(MAX_IO_BITS),
		info_message:"",
		info_title:"",
		special_io_obj:{},
	}

    componentDidMount() {
      this.loadConfig();
    }

	getBit( bitNr, jsonResult) {
		if(bitNr==16) {
			console.log("xxxtest "+JSON.stringify(jsonResult));
		}
		if (jsonResult[bitNr]) return jsonResult[bitNr];
		return "-1";
	}

    loadConfig() {
      	//console.log("---------------------loading deviceIOs");
		var url = ETVConstants.getServerBase()+"/elevator_config?device_id="+this.props.device_id+"&action=get_io_mapping";
      	//console.log("loading url="+url);
      	fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            console.log("xconfig="+JSON.stringify(result));
			var ioMap = {
				bit_0:this.getBit("0",result),
				bit_1:this.getBit("1",result),
				bit_2:this.getBit("2",result),
				bit_3:this.getBit("3",result),
				bit_4:this.getBit("4",result),
				bit_5:this.getBit("5",result),
				bit_6:this.getBit("6",result),
				bit_7:this.getBit("7",result),
				bit_8:this.getBit("8",result),
				bit_9:this.getBit("9",result),
				bit_10:this.getBit("10",result),
				bit_11:this.getBit("11",result),
				bit_12:this.getBit("12",result),
				bit_13:this.getBit("13",result),
				bit_14:this.getBit("14",result),
				bit_15:this.getBit("15",result),
				bit_16:this.getBit("16",result),
				bit_17:this.getBit("17",result),
				bit_18:this.getBit("18",result),
				bit_19:this.getBit("19",result),
				bit_20:this.getBit("20",result),
				bit_21:this.getBit("21",result),
				bit_22:this.getBit("22",result),
				bit_23:this.getBit("23",result),
				bit_24:this.getBit("24",result),
				bit_25:this.getBit("25",result),
				bit_26:this.getBit("26",result),
				bit_27:this.getBit("27",result),
				bit_28:this.getBit("28",result),
				bit_29:this.getBit("29",result),
				bit_30:this.getBit("30",result),
				bit_31:this.getBit("31",result)
			};
			var closing = result['bits_door_closing'];
			if(closing) {
				closing = closing.substring(0,2);
			}else{
				closing = '11';
			}
			var opening = result['bits_door_opening'];
			if(opening) {
				opening = opening.substring(0,2);
			}else{
				opening = '11';
			}
			var open = result['bits_door_open'];
			if(open) {
				open = open.substring(0,2);
			}else{
				open = '01';
			}
			var closed = result['bits_door_closed'];
			if (closed) {
				closed = closed.substring(0,2);
			}else{
				closed = '10';
			}
			var xorMask = result['xor_mask'];
			if(!xorMask || xorMask==='undefined') {
				xorMask = '0'.repeat(MAX_IO_BITS);
			}else if(xorMask.length < MAX_IO_BITS) {
				xorMask = xorMask.padStart(MAX_IO_BITS, '0');
			}
			var doorMap = {open:open,closing:closing,closed:closed,opening:opening};
			var specialIOObj = this.loadSpecialIOConfig(result);
			this.setState({ioMap:ioMap,door_map:doorMap,xor_mask:xorMask,special_io_obj:specialIOObj});
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            this.setState({
              error
            });
          }
        )
    }

	loadSpecialIOConfig( serverConfig) {
		var res = {};
		for(var i=1; i<=16; i++) {
			if(serverConfig["special_io_"+i+".event"]) {
				res["special_io_"+i+".event"] = serverConfig["special_io_"+i+".event"];
				res["special_io_"+i+".value"] = serverConfig["special_io_"+i+".value"];
				res["special_io_"+i+".extra"] = serverConfig["special_io_"+i+".extra"];
			}
		}
		//console.log("--->specialIOObj="+JSON.stringify(res));
		return res;
	}

	getSpecialIOs() {
		var res = [];
		Object.keys(this.state.special_io_obj).forEach(key => {
			var index = this.extractIndexFromKey(key);
			if(!res.includes(index)) res.push(index);
		});
		return res;
	}

	extractIndexFromKey(str) {
		const prefix = "special_io_";
		const suffixIndex = str.indexOf(".", prefix.length);
		
		if (str.startsWith(prefix) && suffixIndex !== -1) {
		  return str.substring(prefix.length, suffixIndex);
		}
		return null; // or throw error / return -1 if needed
	}


    showWindow(divID, show) {
      	show?this.setState({window:divID}):this.setState({window:''});
    }

	addToSpecialIOs(i) {
		var curObj = this.state.special_io_obj;
		var key0 = "special_io_"+i+".event";
		if(curObj.hasOwnProperty(key0)) {
			//already set
			return;
		}
		curObj["special_io_"+i+".event"]="";
		curObj["special_io_"+i+".value"]="";
		curObj["special_io_"+i+".extra"]="";
		this.setState({special_io_obj:curObj});
	}  

	extractNumberFromIOString(str) {
		const lastUnderscoreIndex = str.lastIndexOf('_');
		if (lastUnderscoreIndex === -1) return null;
	  
		const numberPart = str.substring(lastUnderscoreIndex + 1);
		const parsedNumber = parseInt(numberPart, 10);
	  
		return isNaN(parsedNumber) ? null : parsedNumber;
	  }

	setIOMap( key, value) {
		console.log("xxx setting key="+key+" value="+value);
		if(value.indexOf("bit_special_io_")==0) {
			this.addToSpecialIOs(this.extractNumberFromIOString(value));
		}

		var props = this.state.ioMap;
		////console.log(JSON.stringify(props, null, 2));
		props[key]=value;
		this.setState({ioMap:props});
	}

	showInfoMessage(title,msg) {
		this.showWindow('message_div',true);
		this.setState({info_title:title, info_message:msg});
	}

	closeInfoMessage() {
		this.setState({info_message:undefined});
		this.showWindow('message_div',false);
	}

	setDefault() {
		var defaultMap = {
			bit_0:'bit_0_floor',
			bit_1:'bit_1_floor',
			bit_2:'bit_2_floor',
			bit_3:'bit_3_floor',
			bit_4:'bit_4_floor',
			bit_5:'bit_5_floor',
			bit_6:'bit_6_floor',
			bit_7:'bit_out_of_service',
			bit_8:'bit_arriving',
			bit_9:'bit_overload',
			bit_10:'bit_up',
			bit_11:'bit_down',
			bit_12:'bit_fire_alarm',
			bit_13:'bit_door_state_1',
			bit_14:'bit_door_state_2',
			bit_15:'bit_intercom',
			bit_16:'-1',			
			bit_17:'-1',
			bit_18:'-1',
			bit_19:'-1',
			bit_20:'-1',
			bit_21:'-1',
			bit_22:'-1',
			bit_23:'-1',
			bit_24:'-1',
			bit_25:'-1',
			bit_26:'-1',
			bit_27:'-1',
			bit_28:'-1',
			bit_29:'-1',
			bit_30:'-1',
			bit_31:'-1',
			special_io_obj:{},
		};
		this.setState({ioMap:defaultMap});
	}

	setDefaultDoor() {
		var defaultDoor = {closed:'10',opening:'11',open:'01',closing:'11'}
		this.setState({door_map:defaultDoor});
	}

	setDoorConfig( key, value) {
		var props = this.state.door_map;
		//console.log("setDoorConfig key="+key+" value="+value);
		props[key]=value;
		this.setState({door_map:props});
	}

	getInputLabel( bit) {
		//e.g. bit_0
		var nr = parseInt(bit.substring(4,bit.length));
		if(nr<16) return "Adam 1, Input "+nr;
		return "Adam 2, Input "+(nr-16);
	}

	createDropDown( inputKey) {
		var curVal = this.state.ioMap[inputKey];
		//console.log("swVersion="+this.props.sw_version);
		return (
		<FormControl>
				<InputLabel>{this.getInputLabel(inputKey)}</InputLabel>
				<Select
					label={"input_"+this.getInputLabel(inputKey)}
					id={"input_"+inputKey}
					value={curVal}
					size="small"
					style={{ width: 200}}
					onChange={(e)=>{this.setIOMap(inputKey,e.target.value)}}>
					<MenuItem value='-1'>--- undefined ---</MenuItem>
					{[...Array(MAX_FLOOR_BITS)].map((_, i) => (
						<MenuItem key={"floor_bit_"+i} value={"bit_"+i+"_floor"}>FLOOR BIT {i}</MenuItem>
					))}
					<MenuItem value='bit_up'>arrow UP</MenuItem>
					<MenuItem value='bit_down'>arrow Down</MenuItem>
					<MenuItem value='bit_overload'>Overload</MenuItem>
					<MenuItem value='bit_fire_alarm'>Fire Alarm</MenuItem>
					<MenuItem value='bit_out_of_service'>Out of Service</MenuItem>
					<MenuItem value='bit_arriving'>Arriving Signal</MenuItem>
					<MenuItem value='bit_door_state_1'>Door Input 1</MenuItem>
					<MenuItem value='bit_door_state_2'>Door Input 2</MenuItem>
					<MenuItem value='bit_intercom'>Intercom  Signal</MenuItem>
					<MenuItem value='bit_intercom_btn_yes'>Intercom  YES Button</MenuItem>
					<MenuItem value='bit_intercom_btn_no'>Intercom  NO Button</MenuItem>
					<MenuItem value='bit_maintenance'>Maintenance</MenuItem>
					<MenuItem value='bit_emergency_power'>Emergency Power</MenuItem>
					<MenuItem value='bit_service_upper_deck'>Service Upper Deck</MenuItem>
					<MenuItem value='bit_service_lower_deck'>Service Lower Deck</MenuItem>
					<MenuItem value='bit_special_io_1'>Special IO 1 </MenuItem>
					<MenuItem value='bit_special_io_2'>Special IO 2 </MenuItem>
					<MenuItem value='bit_special_io_3'>Special IO 3 </MenuItem>
					<MenuItem value='bit_special_io_4'>Special IO 4 </MenuItem>
					<MenuItem value='bit_special_io_5'>Special IO 5 </MenuItem>
					<MenuItem value='bit_special_io_6'>Special IO 6 </MenuItem>
					<MenuItem value='bit_special_io_7'>Special IO 7 </MenuItem>
					<MenuItem value='bit_special_io_8'>Special IO 8 </MenuItem>
					<MenuItem value='bit_special_io_9'>Special IO 9 </MenuItem>
					<MenuItem value='bit_special_io_10'>Special IO 10 </MenuItem>
					<MenuItem value='bit_special_io_11'>Special IO 11 </MenuItem>
					<MenuItem value='bit_special_io_12'>Special IO 12 </MenuItem>
					<MenuItem value='bit_special_io_13'>Special IO 13 </MenuItem>
					<MenuItem value='bit_special_io_14'>Special IO 14 </MenuItem>
					<MenuItem value='bit_special_io_15'>Special IO 15 </MenuItem>
					<MenuItem value='bit_special_io_16'>Special IO 16 </MenuItem>
				</Select>
			</FormControl>
		)
	}

	createDoorDropDown(inputKey) {
		var curVal = this.state.door_map[inputKey];
		return (
			<FormControl>
				<InputLabel>{inputKey}</InputLabel>
				<Select
					label={inputKey}
					id={"input_"+inputKey}
					value={curVal}
					size="small"
					style={{ width: 200}}
					onChange={(e)=>{this.setDoorConfig(inputKey,e.target.value)}}>
					<MenuItem value='00'>00</MenuItem>
					<MenuItem value='01'>01</MenuItem>
					<MenuItem value='11'>11</MenuItem>
					<MenuItem value='10'>10</MenuItem>
				</Select>
			</FormControl>
		)
	}

	getValue( bitNr) {
		return this.state.ioMap["bit_"+bitNr];
	}

	saveIO() {
		this.showInfoMessage("IO Mapping","Saving IO Mapping...");
		var url = ETVConstants.getServerBase()+"/elevator_config?action=save_io_mapping&device_id="+this.props.device_id;
		//console.log("saving settings");
		for(var i=0; i<MAX_IO_BITS; i++) {
			var val = this.state.ioMap["bit_"+i];
			if (val!=='-1') {
				url += "&"+val+"="+i;
			}
		}
		// add doorstate
		var closed = this.state.door_map["closed"];
		var closing = this.state.door_map["closing"];
		var open = this.state.door_map["open"];
		var opening = this.state.door_map["opening"];
		url += "&bits_door_open="+open+opening;
		url += "&bits_door_opening="+opening+closed;
		url += "&bits_door_closed="+closed+closing;
		url += "&bits_door_closing=" +closing+open;
		var xorMask = this.state.xor_mask || "";
		if(xorMask.length < MAX_IO_BITS) {
			xorMask = xorMask.padStart(MAX_IO_BITS, '0');
		}
		url += "&xor_mask="+xorMask;
		
		var specialIOs = this.getSpecialIOs();
		for(var i=0; i<specialIOs.length; i++) {
			var whichIO = specialIOs[i];
			var key = "special_io_"+whichIO;
			var val0 = this.state.special_io_obj[key+".event"];
			url += "&special_io_"+whichIO+".event="+encodeURIComponent(val0?val0:"");
			var val1 = this.state.special_io_obj[key+".value"];
			url += "&special_io_"+whichIO+".value="+encodeURIComponent(val1?val1:"");
			var val2 = this.state.special_io_obj[key+".extra"];
			url += "&special_io_"+whichIO+".extra="+encodeURIComponent(val2?val2:"");
		}
		//console.log("----------> aaaa URL="+url);
		fetch(url)
			.then(res => res.json())
			.then(
				(result) => {
					this.showInfoMessage("IO Mapping","success");
				},
				(error) => {
					this.setState({
						error
					});
				}
			)
	}

	setSpecialIOEvent( i, val) {
		//console.log("setting special IO("+i+") event="+val);
		var key = "special_io_"+i;
		var objKey = key+".event";
		var cur = this.state.special_io_obj;
		cur[objKey]=val;
		this.setState({special_io_obj:cur});
	}

	createSpecialIOExtra(i) {
		const event = this.state.special_io_obj["special_io_" + i + ".event"];
		const value = this.state.special_io_obj["special_io_" + i + ".value"];
		if (!event || event === 'next_stop') return <span />;

		if (event === 'elevator_touchpad') return <span />;

		if (event === 'multimedia_message') return <Typography variant="body2" color='text.secondary'>{ETVConstants.trans("multimedia_message_expl")}</Typography>;

		if (event === 'streaming') {
			const extraString = this.state.special_io_obj["special_io_" + i + ".extra"] || "";

			const extra = {};
			extraString.split(";").forEach(pair => {
				const [key, val] = pair.split("=");
				if (key && val !== undefined) extra[key] = val;
			});

			const handleExtraChange = (field, newVal) => {
				const newExtra = {
					x: extra.x || 0,
					y: extra.y || 0,
					width: extra.width || 100,
					height: extra.height || 100,
					touch: extra.touch || "no",
					originalWidth: extra.originalWidth || 1920,
					originalHeight: extra.originalHeight || 1080,
					websocket: extra.websocket || "",
					[field]: newVal
				};
				let newExtraString = `x=${newExtra.x};y=${newExtra.y};width=${newExtra.width};height=${newExtra.height};touch=${newExtra.touch}`;
				if (newExtra.touch === 'yes') {
					newExtraString += `;originalWidth=${newExtra.originalWidth};originalHeight=${newExtra.originalHeight};websocket=${newExtra.websocket}`;
				}
				this.setSpecialIOExtra(i, newExtraString);
			};

			return (
				<div style={{
					display: 'flex',
					flexDirection: 'column',
					gap: '16px',
					padding: '16px',
					border: '1px solid #ccc',
					borderRadius: '8px',
					backgroundColor: '#f9f9f9',
					width: 300
				}}>
					<div style={{ display: 'flex', gap: '16px' }}>
						<TextField
							label="X"
							size="small"
							type="number"
							variant="outlined"
							value={extra.x || ''}
							onChange={(e) => handleExtraChange('x', e.target.value)}
							fullWidth
						/>
						<TextField
							label="Y"
							size="small"
							type="number"
							variant="outlined"
							value={extra.y || ''}
							onChange={(e) => handleExtraChange('y', e.target.value)}
							fullWidth
						/>
					</div>
					<div style={{ display: 'flex', gap: '16px' }}>
						<TextField
							label="Width"
							size="small"
							type="number"
							variant="outlined"
							value={extra.width || ''}
							onChange={(e) => handleExtraChange('width', e.target.value)}
							fullWidth
						/>
						<TextField
							label="Height"
							size="small"
							type="number"
							variant="outlined"
							value={extra.height || ''}
							onChange={(e) => handleExtraChange('height', e.target.value)}
							fullWidth
						/>
					</div>
				</div>
			);
		}
	}



	setSpecialIOValue( i, val) {
		console.log("setting special IO("+i+") event="+val);
		var key = "special_io_"+i;
		var objKey = key+".value";
		var cur = this.state.special_io_obj;
		cur[objKey]=val;
		this.setState({special_io_obj:cur});
		//console.log("setting special IO("+i+") value="+val);
	}

	setSpecialIOExtra( i, val) {
		console.log("setting special IO("+i+") extra="+val);
		var key = "special_io_"+i;
		var objKey = key+".extra";
		var cur = this.state.special_io_obj;
		cur[objKey]=val;
		this.setState({special_io_obj:cur});
	}

	createSpecialIO(i) {
		return <Typography variant='h6' style={{marginRight:10}}>Special IO {i}</Typography>
	}

	createSpecialIOValue(i) {
		return (
		  <FormControl fullWidth>
			<TextField
			  size="small"
			  placeholder="Enter value"
			  variant="outlined"
			  value={this.state.special_io_obj["special_io_"+i+".value"]}
			  onChange={(e) => {
				this.setSpecialIOValue(i, e.target.value);
			  }}
			/>
		  </FormControl>
		);
  	}

	createSpecialIOEventDropDown(i) {
		var label = "Special IO Event";
		var value = this.state.special_io_obj["special_io_"+i+".event"];
		return (
			<FormControl fullWidth style={{width:200}}>
			  <InputLabel>{label}</InputLabel>
			  <Select
			  	size="small"
				value={value}
				label={label}
				onChange={(e)=>{this.setSpecialIOEvent(i,e.target.value)}}>
				  <MenuItem key={"special_io_"+i+"_next_stop"} value={"next_stop"}>Next Stop</MenuItem>
				  <MenuItem key={"special_io_"+i+"_message"} value={"message"}>Show Message</MenuItem>
				  <MenuItem key={"special_io_"+i+"_streaming"} value={"streaming"}>Streaming</MenuItem>
				  <MenuItem key={"special_io_"+i+"_elevator_touchpad"} value={"elevator_touchpad"}>Elevator Touchpad</MenuItem>
				  <MenuItem key={"special_io_"+i+"_elevator_touchpad"} value={"multimedia_message"}>Multimedia Message</MenuItem>
			  </Select>
			</FormControl>
		);		
	}

	deleteSpecialIOInfo(i) {
		const curObj = { ...this.state.special_io_obj }; // shallow copy for immutability
		delete curObj["special_io_" + i + ".event"];
		delete curObj["special_io_" + i + ".value"];
		delete curObj["special_io_" + i + ".extra"];
		this.setState({ special_io_obj: curObj });
	}

    render() {
      return(
		<div>
			<Paper style={{marginBottom:20,padding:10}} elevation={5}>
				<FormLabel>ADAM Input Mapping: {this.props.device_id}</FormLabel>
				<Typography variant='body2'>If you need more than 32 inputs, then you will need to add 2 x Adam4051:
					<li>configure first Adam with address 01, second Adam with address 02</li>
					<li>connect RS485 from Adam 1 with Adam 2 in serial mode</li>
				</Typography>
				<br/>
				<Button style={{marginTop:10}} size='small' color="primary" variant='contained' onClick={() => this.setDefault()}>Set Default</Button>
				<table style={{marginTop:20}}>
					<tbody>
						<tr>
							<td><div>{this.createDropDown('bit_0')}</div><br/></td>
							<td><div>{this.createDropDown('bit_8')}</div><br/></td>
							<td><div>{this.createDropDown('bit_16')}</div><br/></td>
							<td><div>{this.createDropDown('bit_24')}</div><br/></td>
						</tr>
						<tr>
							<td><div>{this.createDropDown('bit_1')}</div><br/></td>
							<td><div>{this.createDropDown('bit_9')}</div><br/></td>
							<td><div>{this.createDropDown('bit_17')}</div><br/></td>
							<td><div>{this.createDropDown('bit_25')}</div><br/></td>
						</tr>
						<tr>
							<td><div>{this.createDropDown('bit_2')}</div><br/></td>
							<td><div>{this.createDropDown('bit_10')}</div><br/></td>
							<td><div>{this.createDropDown('bit_18')}</div><br/></td>
							<td><div>{this.createDropDown('bit_26')}</div><br/></td>
						</tr>
						<tr>
							<td><div>{this.createDropDown('bit_3')}</div><br/></td>
							<td><div>{this.createDropDown('bit_11')}</div><br/></td>
							<td><div>{this.createDropDown('bit_19')}</div><br/></td>
							<td><div>{this.createDropDown('bit_27')}</div><br/></td>
						</tr>
						<tr>
							<td><div>{this.createDropDown('bit_4')}</div><br/></td>
							<td><div>{this.createDropDown('bit_12')}</div><br/></td>
							<td><div>{this.createDropDown('bit_20')}</div><br/></td>
							<td><div>{this.createDropDown('bit_28')}</div><br/></td>
						</tr>
						<tr>
							<td><div>{this.createDropDown('bit_5')}</div><br/></td>
							<td><div>{this.createDropDown('bit_13')}</div><br/></td>
							<td><div>{this.createDropDown('bit_21')}</div><br/></td>
							<td><div>{this.createDropDown('bit_29')}</div><br/></td>
						</tr>
						<tr>
							<td><div>{this.createDropDown('bit_6')}</div><br/></td>
							<td><div>{this.createDropDown('bit_14')}</div><br/></td>
							<td><div>{this.createDropDown('bit_22')}</div><br/></td>
							<td><div>{this.createDropDown('bit_30')}</div><br/></td>
						</tr>
						<tr>
							<td><div>{this.createDropDown('bit_7')}</div><br/></td>
							<td><div>{this.createDropDown('bit_15')}</div><br/></td>
							<td><div>{this.createDropDown('bit_23')}</div><br/></td>
							<td><div>{this.createDropDown('bit_31')}</div><br/></td>
						</tr>
					</tbody>
				</table>
				<Divider/>
				<table style={{ marginTop: 10 }}>
				<tbody>
					{this.getSpecialIOs().map((ioKey) => (
					<tr key={ioKey}>
						<td style={{ paddingTop: 10, paddingBottom: 10, verticalAlign: 'top' }}>
						<div>{this.createSpecialIO(ioKey)}</div>
						</td>
						<td style={{ paddingTop: 10, paddingBottom: 10, verticalAlign: 'top' }}>
						<div>{this.createSpecialIOEventDropDown(ioKey)}</div>
						</td>
						<td style={{ paddingTop: 10, paddingBottom: 10, verticalAlign: 'top' }}>
						<div>{this.createSpecialIOValue(ioKey)}</div>
						<div style={{ marginTop: 10 }}>{this.createSpecialIOExtra(ioKey)}</div>
						</td>
						<td style={{ paddingTop: 10, paddingBottom: 10, verticalAlign: 'top' }}>
						<div>
							<IconButton onClick={() => { this.deleteSpecialIOInfo(ioKey) }}>
							<Delete variant="error" />
							</IconButton>
						</div>
						</td>
					</tr>
					))}
				</tbody>
				</table>
			</Paper>

			<Paper style={{marginBottom:20,padding:16}} elevation={5}>
				<FormLabel>Digital IO Inversion (XOR Mask)</FormLabel>
				<Typography variant='body2' color='text.secondary' style={{marginTop:8}}>
					Set a digit to 1 to invert that input. The rightmost digit is bit 0 / Adam 1 input 0.
				</Typography>
				<div style={{width:620, maxWidth:'100%', marginTop:18}}>
					<div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:8}}>
						<div style={{border:'1px solid #d0d7de', borderRadius:6, padding:'4px 8px', background:'#f6f8fa'}}>
							<Typography variant='caption' style={{fontFamily:'monospace', fontWeight:700}}>bit {MAX_IO_BITS - 1}</Typography>
						</div>
						<Typography variant='caption' color='text.secondary' style={{flex:1, textAlign:'center', letterSpacing:1}}>
							Adam 2 inputs &larr; mask direction &rarr; Adam 1 inputs
						</Typography>
						<div style={{border:'1px solid #1976d2', borderRadius:6, padding:'4px 8px', background:'#eaf3ff', color:'#1976d2'}}>
							<Typography variant='caption' style={{fontFamily:'monospace', fontWeight:700}}>bit 0</Typography>
						</div>
					</div>
					<TextField
						fullWidth
						size='small'
						key='xor_mask'
						variant='outlined'
						value={this.state.xor_mask}
						helperText="Example: 00000000000000000000000000000001 inverts bit 0"
						inputProps={{maxLength: MAX_IO_BITS, style:{fontFamily:'monospace', fontSize:16, letterSpacing:3, textAlign:'center', padding:'12px 10px', background:'#fbfdff'}}}
						onChange={(e)=>{this.setState({xor_mask:e.target.value.replace(/[^01]/g, '')})}} />
					<div style={{display:'flex', justifyContent:'space-between', marginTop:2, padding:'0 4px'}}>
						<Typography variant='caption' color='text.secondary'>Most significant side</Typography>
						<Typography variant='caption' color='primary'>bit 0 starts here</Typography>
					</div>
				</div>
			</Paper>
			
			<Paper style={{marginBottom:20,padding:10}} elevation={5}>
				<FormLabel>Setting Door Behaviour</FormLabel>
				<br/>
				<Button style={{marginTop:10}} size='small' color="primary" variant='contained' onClick={() => this.setDefaultDoor()}>Set Default</Button>
				<table style={{marginTop:20}}>
					<tbody>
						<tr>
							<td><div>{this.createDoorDropDown('closed')}</div><br/></td>
						</tr>
						<tr>
							<td><div>{this.createDoorDropDown('opening')}</div><br/></td>
						</tr>
						<tr>
							<td><div>{this.createDoorDropDown('open')}</div><br/></td>
						</tr>
						<tr>
							<td><div>{this.createDoorDropDown('closing')}</div><br/></td>
						</tr>
					</tbody>
				</table>
			</Paper>

			<Paper style={{marginBottom:20,padding:10}} elevation={5}>
				<FormLabel>Out of Service Notification</FormLabel>
				<table style={{marginTop:10}}>
					<tbody>
						<tr>
								<td><div><TextField size='small' key='email' label="email" variant='outlined' value='' /></div></td>
						</tr>
						<tr>
								<td><div><TextField size='small' key='sms' label="SMS" variant='outlined' value='' /></div></td>
						</tr>
						<tr>
								<td><div><TextField size='small' key='trigger' label="trigger [min]" variant='outlined' value='' /></div></td>
						</tr>
					</tbody>
				</table>
			</Paper>
			 <Button variant="contained" startIcon={<Save/>} color="primary" onClick={() => this.saveIO()}>{ETVConstants.trans("save")}</Button>

			<div id='message_div' style={{display:this.state.window==='message_div'?'block':'none'}}>
				<Card>
					<CardContent>
						<InfoMessage2 title={this.state.info_title} message={this.state.info_message} />
					</CardContent>
					<CardActions>
						<Button color="primary" variant='outlined' onClick={() => this.closeInfoMessage()}>{ETVConstants.trans("close")}</Button>
					</CardActions>
				</Card>
			</div>
		   	</div>
			);
	}
}

export default EditIO
